import { Box } from "@mui/material";
import {
  attachmentsScrollRowSx,
  onAttachmentsRowWheel,
} from "./attachmentChipTheme";

const AttachmentsScrollRow = ({ children }) => (
  <Box sx={attachmentsScrollRowSx} onWheel={onAttachmentsRowWheel}>
    {children}
  </Box>
);

export default AttachmentsScrollRow;
